import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken, getAccessToken, getRole } from "@/core/token";

interface GuardRouteProps {
  isPrivate: boolean;
  children: React.ReactNode;
}

const GuardRoute = ({ isPrivate, children }: GuardRouteProps) => {
  const token = getToken() || getAccessToken();
  const location = useLocation();

  const isAuthenticated = !!token;

  if (!isAuthenticated && isPrivate) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isAuthenticated && !isPrivate || isAuthenticated && location.pathname === '/') {
    return <Navigate to="/deliveries" replace />;
  }

  return <>{children}</>;
};

export default GuardRoute;
